export const VeryLikelyToDefaultConstant = 'vy'
export const LikelyToDefaultConstant = 'y'
export const UnLikelyToDefaultConstant = 'n'
